import axios from "axios";
import { Banner } from "../interfaces/banner.interface";

class BannersApi {

  getBanners(category?: string): Promise<Banner[]> {
    const apiUrl = category ? `/api/v1/banner?category=${category}` : "/api/v1/banner";

    return axios.get(apiUrl)
    .then(response => {
      const banners = response.data.data.attributes.slides.map(slide => {
        const banner:Banner = {
          title: slide.title,
          url: slide.url,
          target: slide.target,
          sortOrder: slide.sort_order,
          desktopImage: slide.image.desktop,
          mobileImage: slide.image.mobile
        }
        return banner;
      })
      return Promise.resolve(banners);
    });
  }

}

export default BannersApi;